<template>
    <div class="container">
        <div class="header-section">
            <van-button @click="$router.go(-1)" plain round size="mini" icon="arrow-left" type="info" class="back-button"></van-button>
            <h2 class="page-title">断语生成</h2>
        </div>

        <!-- 特定用户的额外功能 -->
        <div v-if="isSpecialUser" class="special-user-section">
            <h3 class="section-title">AI断语生成</h3>
            <el-form :model="aiForm" label-position="top" class="ai-form">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="出生日期">
                            <el-date-picker
                                v-model="aiForm.birth"
                                type="datetime"
                                placeholder="选择日期时间"
                                style="width: 100%"
                                format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别">
                            <el-select v-model="aiForm.sex" placeholder="请选择性别" style="width: 100%">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="起始年份">
                            <el-date-picker
                                v-model="aiForm.start"
                                type="year"
                                placeholder="选择起始年份"
                                style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="结束年份">
                            <el-date-picker
                                v-model="aiForm.end"
                                type="year"
                                placeholder="选择结束年份"
                                style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="标签">
                    <el-select v-model="aiForm.select" placeholder="请选择标签" style="width: 100%">
                        <el-option label="感情" value="感情"></el-option>
                        <el-option label="事业" value="事业"></el-option>
                        <el-option label="前运" value="前运"></el-option>
                        <el-option label="流年" value="流年"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="generateAIWords" :loading="aiLoading" class="generate-button">生成AI断语</el-button>
                </el-form-item>
            </el-form>
            
            <div v-if="aiResult" class="ai-result">
                <div class="result-card">
                    <p>{{ aiResult }}</p>
                    <el-button class="copy-button" size="small" round
                        v-clipboard:copy="aiResult"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">
                        <i class="el-icon-document-copy"></i> 复制
                    </el-button>
                </div>
            </div>
        </div>

        <div class="divider" v-if="isSpecialUser"></div>

        <h3 class="section-title">传统断语生成</h3>
        <el-form ref="dynamicValidateForm" :model="dynamicValidateForm" class="dynamic-form">
            <div v-for="(domain, index) in dynamicValidateForm.wordList" :key="index" class="form-item-card">
                <el-row :gutter="15">
                    <el-col :span="6">
                        <el-form-item :rules="[{ required:true, message: '输入不能为空'}]">
                            <el-select v-model="domain.type" style="width:100%" clearable placeholder="请选择前后运" @change="selectParentList">
                                <el-option v-for="(item,i) in typeList" :key="`${i}type`" :label="item" :value="item" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :rules="[{ required:true, message: '输入不能为空'}]">
                            <el-select v-model="domain.parent" style="width:100%" clearable placeholder="请选择母类型" @change="selectSonList">
                                <el-option v-for="(item,i) in parentList" :key="`${i}par`" :label="item" :value="item" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!(domain.parent.indexOf('原生')>= 0 || domain.parent.indexOf('用神')>= 0)" :span="6">
                        <el-form-item :rules="[{ required:true, message: '输入不能为空'}]">
                            <el-select v-model="domain.year" style="width:100%" clearable placeholder="请选择年份" @change="selectSonList">
                                <el-option v-for="(item,i) in yearList" :key="`${i}par`" :label="item" :value="item" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :rules="[{ required:true, message: '输入不能为空'}]">
                            <el-select v-model="domain.son" style="width:100%" clearable placeholder="请选择子类型">
                                <el-option v-for="(item,i) in sonList" :key="`${i}son`" :label="item" :value="item"/>
                            </el-select>                
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="form-actions">
                <el-button type="primary" icon="el-icon-plus" circle @click="addDomain" class="action-button" />
                <el-button v-if="dynamicValidateForm.wordList.length > 1" type="danger" icon="el-icon-minus" circle @click="removeDomain" class="action-button" />
            </div>
        </el-form>
        
        <div class="generate-section">
            <el-button type="primary" @click="output" class="generate-button">生成断语</el-button>
        </div>
        
        <div v-if="word && word.length > 0" class="result-section">
            <div class="result-card">
                <div v-for="(item, index) in word" :key="index" class="result-item">
                    {{ item }}
                </div>
                <div class="copy-section">
                    <el-button class="copy-button" size="small" round
                        v-clipboard:copy="totalword"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">
                        <i class="el-icon-document-copy"></i> 复制全部
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { postAction } from '@/api/manage'
export default {
  data () {
    return {
      dynamicValidateForm: {
        wordList: [{
          type: '',
          parent: '',
          year:'',
          son: '',
          content: ''
        }]
      },
      dictList:[{
          key:'',
          value:''
      }],
      typeList:[],
      parentList:[],
      parentListTemp:[],
      sonList:[],
      listLoading:false,
      word:'',
      yearList: Array.from({ length: 91 }, (_, i) => (2060 - i).toString()), // 从2060年倒序到1970年
      // 特定用户的数据
      isSpecialUser: true,
      username: '',
      aiForm: {
        birth: '',
        sex: '',
        start: '',
        end: '',
        select: ''
      },
      aiLoading: false,
      aiResult: ''
    }
  },
  created(){
      this.getDict()
      this.checkSpecialUser()
  },
  methods:{
    checkSpecialUser() {
      const username = localStorage.getItem("clientname")
      this.username = username
      // if (username === '张旭诏') {
      //   this.isSpecialUser = true
      // }
    },
    generateAIWords() {
      // 检查所有字段是否已填写
      if (!this.aiForm.birth || !this.aiForm.sex || !this.aiForm.start || !this.aiForm.end || !this.aiForm.select) {
        this.$message.warning('请填写所有字段')
        return
      }
      
      this.aiLoading = true
      const url = '/oa/aiwords'
      
      // 格式化年份
      const startYear = this.aiForm.start instanceof Date ? this.aiForm.start.getFullYear() : this.aiForm.start
      const endYear = (this.aiForm.end instanceof Date ? this.aiForm.end.getFullYear() : this.aiForm.end) + 1 // 结束年份加1
      
      // 格式化出生日期为 yyyy-MM-dd-HH
      let birthFormatted = ''
      if (this.aiForm.birth) {
        const birthDate = new Date(this.aiForm.birth)
        const year = birthDate.getFullYear()
        const month = String(birthDate.getMonth() + 1).padStart(2, '0')
        const day = String(birthDate.getDate()).padStart(2, '0')
        const hour = String(birthDate.getHours()).padStart(2, '0')
        birthFormatted = `${year}-${month}-${day}-${hour}`
      }
      
      postAction(url, {
        birth: birthFormatted,
        sex: this.aiForm.sex,
        start: startYear,
        end: endYear, // 使用加1后的结束年份 
        select: this.aiForm.select,
        user: this.username
      }).then(res => {
        this.aiLoading = false
        if (res.data.code === 200) {
          this.aiResult = res.data.msg
        } else {
          this.$message.error(res.data.msg || '生成失败')
        }
      }).catch(() => {
        this.aiLoading = false
        this.$message.error('请求失败')
      })
    },
    totalword(){
      return this.word.join('\n');
    },
    getDict(){
        const url = '/oa/getDict'
        postAction(url).then( res => {
		     if (res.data.code === 200) {
                this.dictList = res.data.msg
                this.typeList = this.dictList.map(item => item.tag)
                console.log('typeList',this.typeList)
		      } else {
                this.$message.error(res.data.msg)
		     }
          })
    },
    selectParentList(val){
      const tempList = this.dictList.find(item => item.tag === val).flag
      this.parentListTemp = tempList
      this.parentList = tempList.map(item => item.mum)
    },
    selectSonList(val){
      const tempList = this.parentListTemp.find(item => item.mum === val)
      this.sonList = tempList.son
    },
    output () {
      this.$refs.dynamicValidateForm.validate((valid) => {
        if (valid) {
        const url = '/oa/outword'
        postAction( url, this.dynamicValidateForm).then( res => {
		     if (res.data.code === 200) {
                 this.word = res.data.msg.word
		      } else {
              this.$message.error(res.data.msg)
		     }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    removeDomain () {
      const length = this.dynamicValidateForm.wordList.length
      if (length > 1) {
        this.dynamicValidateForm.wordList.splice(length - 1, 1)
      }
    },
    addDomain () {
      this.dynamicValidateForm.wordList.push({
          type: '',
          parent: '',
          son: '',
          content: ''
      })
    },
    // 复制成功
    onCopy (e) {
      this.$message({
        showClose: true,
        message: '复制成功',
        type: 'success'
      })
    },
    // 复制失败
    onError (e) {
      this.$message.error('复制失败')
    }
  }
}
</script>
<style scoped>
.container{
  padding: 10px 0px;
}
.header-section{
    display:flex;
    justify-content: center;
    align-items: center;
}
.time{
  display: flex;
  justify-content: space-between;
}
.line{
  display: flex;
  justify-content: center;
}
::v-deep  .el-form-item{
  margin-bottom: 0px;
}
.info-card{
	width: 80%;
	padding: 2px;
}
.formList{
   border: 1px solid #ddd;
   padding: 4px;
   margin-top: 0px;
}
.dialog-footer{
	text-align: center;
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled){
	color: #000;
 }
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #1890ff;
}

.special-user-section {
  margin-bottom: 30px;
}

.ai-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.dynamic-form {
  margin-top: 20px;
}

.form-item-card {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin: 15px 0;
}

.action-button {
  margin-left: 10px;
}

.generate-section {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.generate-button {
  padding: 12px 30px;
  font-size: 16px;
}

.result-section {
  margin-top: 30px;
}

.result-card {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.result-item {
  margin-bottom: 10px;
  line-height: 1.6;
  color: #606266;
}

.copy-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.copy-button {
  color: #409EFF;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.copy-button:hover {
  color: #fff;
  background-color: #409EFF;
  border-color: #409EFF;
}

.divider {
  height: 1px;
  background-color: #dcdfe6;
  margin: 30px 0;
}

.ai-result {
  margin-top: 20px;
}

/* 覆盖 Element UI 样式 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-button--primary {
  background-color: #409EFF;
}

::v-deep .el-button--primary:hover {
  background-color: #66b1ff;
}
</style>
